import { Hand } from './Hand.js';

export const SEAT_COLORS = Object.freeze({
  p1: '#d4a017',
  p2: '#ef4444',
  p3: '#10b981',
  p4: '#3b82f6',
  p5: '#a855f7',
  p6: '#ec4899',
  p7: '#f97316',
  p8: '#06b6d4',
  you: '#d4a017',
  cpu: '#ef4444',
  team1: '#d4a017',
  team2: '#ef4444',
  team3: '#10b981',
  team4: '#3b82f6'
});

/**
 * Player Model representing a seat participant in Crazy Cribbage.
 */
export class Player {
  constructor(data = {}) {
    Object.assign(this, data);
    this.id = String(data.id || 'p1');
    this.name = String(data.name || (this.id.toUpperCase()));
    this.type = data.type === 'cpu' ? 'cpu' : 'human';
    this.personality = data.personality || 'shark';
    this.team = data.team || null;
    this.color = data.color || SEAT_COLORS[this.id] || '#d4a017';
    this.score = Number(data.score || 0);
    this.prevScore = Number(data.prevScore || 0);
    this.hand = (data.hand instanceof Hand) ? data.hand : new Hand(data.hand);
    this.kept = (data.kept instanceof Hand) ? data.kept : new Hand(data.kept);
    this.cutCard = data.cutCard || null;
  }

  get isCpu() {
    return this.type === 'cpu';
  }

  get isHuman() {
    return this.type === 'human';
  }

  resetForNewRound() {
    this.hand.clear();
    this.kept.clear();
    this.cutCard = null;
  }

  addScore(points) {
    this.prevScore = this.score;
    this.score += points;
    return this.score;
  }

  toPlain() {
    return {
      id: this.id,
      name: this.name,
      type: this.type,
      personality: this.personality,
      team: this.team,
      color: this.color,
      score: this.score,
      prevScore: this.prevScore,
      hand: this.hand.toPlain(),
      kept: this.kept.toPlain(),
      cutCard: this.cutCard
    };
  }
}
